import React, { useState } from 'react';
import { useEffect } from 'react';
import OverlayComponentPopUp from './overlay-component-pop-up';

const OverlayComponenMandatoryStep = () => {
  const [isPermissionDenied, setPermissionDenied] = useState(false);
  const permissionObject = navigator.permissions.query({ name: 'geolocation' });
  console.log(permissionObject);

  useEffect(() => {
    const successCallback = (position) => {
      console.log('Permission granted', position);
    };

    const errorCallback = (error) => {
      console.log(error);
      setPermissionDenied(true);
    };

    permissionObject.then((result) => {
      if (result.state === 'prompt') {
        navigator.geolocation.getCurrentPosition(
          successCallback,
          errorCallback
        );
      }
    });
  }, [isPermissionDenied]);

  return (
    <>
      {!isPermissionDenied ? (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
          <h2 className="text-center text-white text-xl font-semibold">
            This is a mandatory step
          </h2>
        </div>
      ) : (
        <OverlayComponentPopUp />
      )}
    </>
  );
};

export default OverlayComponenMandatoryStep;
